import React from "react";
import { Modal } from "antd";
import { Trash2 } from "lucide-react";

function DeleteResumeModal({
  deleteModal,
  setDeleteModal,
  resume,
  deleteResumeApi,
}) {
  const handleClose = () => {
    setDeleteModal(false);
  };

  const handleConfirm = () => {
    deleteResumeApi(resume?.resumeIdentifier);
    handleClose();
  };

  return (
    <Modal
      open={deleteModal}
      onCancel={handleClose}
      footer={null}
      centered
      width={460}
    >
      <div className="flex flex-col gap-[.6rem]">
        <div className="w-14 h-14 rounded-full bg-red-50 flex items-center justify-center">
          <Trash2 size={24} className="text-red-600" />
        </div>

        <p className="text-[1.08rem] font-semibold text-[#0F1B23] mb-0">
          Delete resume?
        </p>

        <p className="text-sm text-[#475467] max-w-[360px]">
          Are you sure you want to delete
          {resume?.resumeFileName ? (
            <>
              {" "}
              <span className="font-semibold text-[#0F1B23] break-all">
                {resume.resumeFileName}
              </span>
            </>
          ) : (
            " this resume"
          )}
          ? This action cannot be undone.
        </p>
      </div>

      <div className="flex items-center gap-3 mt-6">
        <button
          className="btn-white px-3 py-2 rounded-lg sm:w-1/2 w-full"
          onClick={handleClose}
        >
          Cancel
        </button>

        <button
          onClick={handleConfirm}
          className="btn-orange px-3 py-2 rounded-lg sm:w-1/2 w-full"
        >
          Delete
        </button>
      </div>
    </Modal>
  );
}

export default DeleteResumeModal;
